export const MODULE_GA = 'ga'
export const MODULE_GTAG = 'gtag'
export const MODULE_MIXPANEL = 'mixpanel'
export const MODULE_SEGMENT = 'segment'
export const MODULE_FACEBOOK = 'facebook'
export const MODULE_MPARTICLE = 'mparticle'
export const MODULE_MATOMO = 'matomo'
